import { Container, StyledShowcase } from './styles/Container.style';
import { StyledHeader, Image } from './styles/Header.style';
import { Flex } from './styles/Flex.style';
import content from './../content';
import Card from './Card';

export default function Services() {
	return (
		<>
			<StyledHeader
				style={{
					backgroundImage: '../images/Colorful-Abstract-Background.svg',
				}}
			>
				<Container>
					<StyledShowcase>
						<h1>ALL BENEFITS AND SERVICES</h1>
						<Flex>
							<div>
								<Image src='./images/technical-support.svg' />
								<p>Support</p>
							</div>
							<div>
								<Image src='./images/camera.svg' />
								<p></p>
							</div>
							<div>
								<Image src='./images/Rubick-cube.svg' />
								<p></p>
							</div>
						</Flex>
					</StyledShowcase>
				</Container>
			</StyledHeader>
			<Container>
				{/* From a file  */}
				{content.map((item, index) => (
					<Card key={index} item={item} />
				))}
			</Container>
		</>
	);
}
